import React from "react";
import TooltipButton from "../TooltipButton";
import { ISuggestionsBtn } from "../@types";
import { SEARCH_MODALS_NAMES } from "../../../search/hooks/useSearchModals";

export const SuggestionsBtn = ({ onClick }: ISuggestionsBtn) => (
  <TooltipButton
    onClick={() => onClick({ type: SEARCH_MODALS_NAMES.SUGGESTIONS })}
    type="bulb"
    label="Suggestions"
  />
);
